import React, { useState, useEffect } from 'react';
import apiService from '../services/api';

const LoginForm = ({ onLogin, onClose }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [totpCode, setTotpCode] = useState('');
  const [needsTotp, setNeedsTotp] = useState(false);
  const [totpEnabled, setTotpEnabled] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    apiService.getAuthTotpStatus()
      .then((data) => setTotpEnabled(!!data.enabled))
      .catch(() => setTotpEnabled(false));
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      setError('');

      const response = await apiService.verifyPassword(
        username,
        password,
        needsTotp ? totpCode : undefined
      );

      if (response.success) {
        onLogin(response.token);
        return;
      }

      if (response.requiresTotp) {
        setNeedsTotp(true);
        setError(response.error || '');
        return;
      }

      setError(response.error || 'Nieprawidłowa nazwa użytkownika lub hasło');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message === 'Failed to fetch'
        ? 'Błąd połączenia z serwerem'
        : (err.message || 'Błąd połączenia z serwerem'));
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    setNeedsTotp(false);
    setTotpCode('');
    setError('');
  };

  const handleClose = () => {
    setUsername('');
    setPassword('');
    setTotpCode('');
    setNeedsTotp(false);
    setError('');
    onClose();
  };

  return (
    <div className="login-overlay">
      <div className="login-form">
        <div className="login-header">
          <h2>Panel Administratorski</h2>
          <button type="button" className="close-btn" onClick={handleClose}>×</button>
        </div>

        <form onSubmit={handleLogin}>
          {!needsTotp ? (
            <>
              <div className="form-group">
                <label htmlFor="username">Użytkownik:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className="username-input"
                  placeholder="Użytkownik"
                  autoComplete="username"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Hasło:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="password-input"
                  autoComplete="current-password"
                />
              </div>

              {totpEnabled && (
                <p className="login-hint">Po zalogowaniu wymagany będzie kod z aplikacji uwierzytelniającej.</p>
              )}
            </>
          ) : (
            <>
              <p className="login-totp-info">
                Wpisz 6-cyfrowy kod z Google Authenticator lub innej aplikacji 2FA.
              </p>
              <div className="form-group">
                <label htmlFor="totpCode">Kod uwierzytelniający:</label>
                <input
                  type="text"
                  id="totpCode"
                  value={totpCode}
                  onChange={(e) => setTotpCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
                  required
                  className="totp-input"
                  placeholder="000000"
                  inputMode="numeric"
                  autoComplete="one-time-code"
                  maxLength={6}
                  pattern="\d{6}"
                  autoFocus
                />
              </div>
            </>
          )}

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            {needsTotp ? (
              <button type="button" onClick={handleBack} className="cancel-btn">
                Wstecz
              </button>
            ) : (
              <button type="button" onClick={handleClose} className="cancel-btn">
                Anuluj
              </button>
            )}
            <button
              type="submit"
              className="submit-btn"
              disabled={isLoading || (needsTotp && totpCode.length !== 6)}
            >
              {isLoading ? 'Logowanie...' : needsTotp ? 'Potwierdź kod' : 'Zaloguj się'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;
